module.exports = __webpack_public_path__ + "static/media/HDQuali-about.4e4b8dec.jpg";